import ChangePassModal from './ChangePassContainer';

export default ChangePassModal;
